<button
  tabindex="-1"
  mat-icon-button
  (click)="close()"
>
  <mat-icon>close</mat-icon>
</button>
